import questionsTypes from '../types/questions';
import api from '../../api/api';
import agentsTypes from "../types/agents";

const setQuestionsList = (array) => ({
    type: questionsTypes.SET_QUESTIONS_LIST,
    array,
});

const setQuestionsInfoList = (array) => ({
    type: questionsTypes.SET_QUESTIONS_INFO_LIST,
    array,
});

const setCommonQuestionsList = (array) => ({
    type: questionsTypes.SET_COMMON_QUESTIONS_LIST,
    array,
});

const setTopic = (string) => ({
    type: questionsTypes.SET_TOPIC,
    string,
});

const setQuestionsTopicList = (array) => ({
    type: questionsTypes.SET_QUESTIONS_TOPIC_LIST,
    array,
});

const setSearchString = (string) => ({
    type: questionsTypes.SET_SEARCH_STRING,
    string,
});

const setSearchMatches = (matches) => ({
    type: questionsTypes.SET_SEARCH_MATCHES,
    matches,
});

const setSearchRequest = (string) => ({
    type: questionsTypes.SET_SEARCH_REQUEST,
    string,
});

const setSearchResults = (array) => ({
    type: questionsTypes.SET_SEARCH_RESULTS,
    array,
});

const setItemToScroll = (object) => ({
    type: questionsTypes.SET_ITEM_TO_SCROLL,
    object,
})

const setLoadingQuestions = (boolean) => ({
    type: questionsTypes.SET_LOADING_QUESTIONS,
    boolean,
});

const fetchQuestions = (page, topic) => async (dispatch) => {
    dispatch(setLoadingQuestions(true))
    const responseData = [];
    const questions = [];
    let question = {};
    let answerShort = '';
    const response = await api.get(`/questions`);
    
    // Check if response is valid JSON (not PHP code or HTML)
    if (typeof response.data === 'string' && (response.data.includes('<?php') || response.data.includes('<!DOCTYPE'))) {
        console.error('Backend returned PHP/HTML instead of JSON. Check proxy configuration.');
        console.error('Response:', response.data.substring(0, 200));
        dispatch(setLoadingQuestions(false));
        return;
    }
    
    // API Platform returns data in hydra:member format
    // Handle different response formats
    let dataArray = [];
    if (response.data) {
        if (Array.isArray(response.data)) {
            dataArray = response.data;
        } else if (response.data['hydra:member'] && Array.isArray(response.data['hydra:member'])) {
            dataArray = response.data['hydra:member'];
        } else if (response.data['@graph'] && Array.isArray(response.data['@graph'])) {
            dataArray = response.data['@graph'];
        } else {
            console.warn('Unexpected response format:', response.data);
            dataArray = [];
        }
    }
    
    if (!Array.isArray(dataArray) || dataArray.length === 0) {
        console.warn('No questions data found in response');
        dispatch(setLoadingQuestions(false));
        return;
    }
    
    dataArray.forEach((elem) => {
        responseData.push({...elem});
    })
    responseData.forEach((elem) => {
        question = {};
        question.id = responseData.indexOf(elem);
        question.question = elem.question;
        question.answer = elem.answer;
        question.display = {
            ranch: 0,
            home: 0,
            manufactured: 0,
            landlord: 0,
            churches: 0,
            commercial: 0,
            claims: 0,
            topic_policy: 0,
            topic_billing: 0,
            topic_claims: 0,
            topic_identity: 0,
        }
        elem.blocks.forEach((block) => {
            switch (block) {
                case "/api/blocks/1" :
                    question.display.ranch = 1;
                    break;
                case "/api/blocks/2" :
                    question.display.home = 1;
                    break;
                case "/api/blocks/3" :
                    question.display.manufactured = 1;
                    break;
                case "/api/blocks/4" :
                    question.display.landlord = 1;
                    break;
                case "/api/blocks/5" :
                    question.display.churches = 1;
                    break;
                case "/api/blocks/6" :
                    question.display.commercial = 1;
                    break;
                case "/api/blocks/7" :
                    question.display.claims = 1;
                    break;
                case "/api/blocks/8" :
                    question.display.topic_policy = 1;
                    break;
                case "/api/blocks/9" :
                    question.display.topic_billing = 1;
                    break;
                case "/api/blocks/10" :
                    question.display.topic_claims = 1;
                    break;
                case "/api/blocks/11" :
                    question.display.topic_identity = 1;
                    break;
                default : break;
            }
        });

        answerShort = question.answer.split(/<p>|<\/p>/)[1];
        answerShort = answerShort.split(/<a|<\/a>/)[0];
        question.answer_short = answerShort.split(/\./)[0] + '...';

        questions.push(question);
    });

    if (page === 'infoCenter'){
        dispatch(setInfoCenterList(questions, topic));
        dispatch(setLoadingQuestions(false))
    }
    if (page === 'common'){
        dispatch(formationCommonQuestionsList(questions, topic));
        dispatch(setLoadingQuestions(false))
    }
};

const setInfoCenterList = (questionsList, topic) => async (dispatch) => {
    const questionsInfoList = [];
    questionsList.forEach((question) => {
        switch (1) {
            case question.display.topic_policy : questionsInfoList.push({...question})
                break;
            case question.display.topic_billing : questionsInfoList.push({...question})
                break;
            case question.display.topic_claims : questionsInfoList.push({...question})
                break;
            case question.display.topic_identity : questionsInfoList.push({...question})
                break;
            default: break;
        }
    });
    dispatch(setQuestionsInfoList(questionsInfoList));
    dispatch(changeTopicList(questionsInfoList, topic));
}

const formationCommonQuestionsList = (questionsList, type) => async (dispatch) => {
    let commonQuestionList = [];
    questionsList.forEach((elem) => {
        if (type === 'FARM_AND_RANCH' && elem.display.ranch){
            commonQuestionList.push(elem)
        }
        if (type === 'HOME_OWNERS' && elem.display.home){
            commonQuestionList.push(elem)
        }
        if (type === 'MANUFACTURED' && elem.display.manufactured){
            commonQuestionList.push(elem)
        }
        if (type === 'LANDLORD' && elem.display.landlord){
            commonQuestionList.push(elem)
        }
        if (type === 'ORGANIZATION' && elem.display.churches){
            commonQuestionList.push(elem)
        }
        if (type === 'COMMERCIAL' && elem.display.commercial){
            commonQuestionList.push(elem)
        }
        if (type === 'CLAIMS' && elem.display.claims){
            commonQuestionList.push(elem)
        }
    });
    dispatch(setCommonQuestionsList(commonQuestionList));
}

const changeTopicList = (questionsInfoList, topic) => async (dispatch) => {
    let questionsTopicList = [];
    questionsInfoList.forEach((elem) => {
        if (topic === 'POLICY' && elem.display.topic_policy){
            questionsTopicList.push(elem)
        }
        if (topic === 'BILLING' && elem.display.topic_billing){
            questionsTopicList.push(elem)
        }
        if (topic === 'CLAIMS' && elem.display.topic_claims){
            questionsTopicList.push(elem)
        }
        if (topic === 'IDENTITY' && elem.display.topic_identity){
            questionsTopicList.push(elem)
        }
    })
    dispatch(setQuestionsTopicList(questionsTopicList));
}

const fetchSearchResults = (request, list) => async (dispatch) => {

    let resultsList = [];
    let resultItem;

    if (request.length > 0) {
        const requestLower = request.toLowerCase();
        const requestLowerSplit = requestLower.split('');
        list.forEach((item) => {
            if (item.question.toLowerCase().includes(requestLower) || item.answer.toLowerCase().includes(requestLower)){
                resultItem = {...item};
                resultItem.question = highlight(resultItem.question, requestLowerSplit);

                if (resultItem.answer_short.toLowerCase().includes(requestLower)){
                    resultItem.answer_short = highlight(resultItem.answer_short, requestLowerSplit);
                }

                resultsList.push(resultItem);
            }
        });
    }
    dispatch(setSearchResults(resultsList));
    return false;
};


const searchMatches = (string, list) => async (dispatch) => {
    let matchesList = [];
    let matchItem;
    const stringLower = string.toLowerCase();
    const stringLowerSplit = stringLower.split('');
    if (string.length > 0) {
        list.forEach((item) => {
            if (item.question.toLowerCase().includes(stringLower)){
                matchItem = {...item};
                matchItem.question = highlight(matchItem.question, stringLowerSplit);
                matchesList.push(matchItem);
            }
        });
    }

    dispatch(setSearchMatches(matchesList));
    return false;
}

const highlight = (valueString, requestLowerArray) => {
    let valueStringSplit = valueString.split('');
    for (let i = 0; i < valueStringSplit.length; i++) {
        if (valueStringSplit[i].toLowerCase() === requestLowerArray[0]) {
            let isMatch = true
            for (let y = 0; y < requestLowerArray.length; y++) {
                if (!valueStringSplit[i + y] || valueStringSplit[i + y].toLowerCase() !== requestLowerArray[y]){
                    isMatch = false
                }
            }
            if (isMatch === true) {
                valueStringSplit[i] = `<mark>${valueStringSplit[i]}`;
                valueStringSplit[i + requestLowerArray.length - 1] = `${valueStringSplit[i + requestLowerArray.length - 1]}</mark>`;
            }
        }
    }
    return valueStringSplit.join('');
}


export default {
    setQuestionsList,
    setTopic,
    setQuestionsTopicList,
    setCommonQuestionsList,
    setSearchString,
    setSearchMatches,
    setSearchRequest,
    setSearchResults,
    fetchQuestions,
    changeTopicList,
    fetchSearchResults,
    searchMatches,
    setItemToScroll,
    setLoadingQuestions
};
